import NewConstructionLayout from './NewConstructionLayout';

export default NewConstructionLayout;
